import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Samples extends Component {
  static propTypes = {
    fdata: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      openSamples: []
    };
  }

  onClickSample = index => {
    if (this.state.openSamples.includes(index)) {
      this.setState({
        openSamples: this.state.openSamples.filter(sample => sample !== index)
      });
    } else {
      this.setState({
        openSamples: [...this.state.openSamples, index]
      });
    }
  };

  padZero = (number, length) => {
    let myString = '' + number;
    while (myString.length < length) {
      myString = '0' + myString;
    }

    return myString;
  };

  render() {
    const { fdata } = this.props;

    let ehraf_docs = '';

    fdata.ehraf &&
      fdata.ehraf_docs.forEach(doc => {
        if (ehraf_docs === '') {
          ehraf_docs = ehraf_docs + doc.document_no;
          if (doc.coverage !== 'entire') {
            ehraf_docs = ehraf_docs + '(' + doc.coverage + ')';
          }
        } else {
          ehraf_docs = ehraf_docs + ', ' + doc.document_no;
          if (doc.coverage !== 'entire') {
            ehraf_docs = ehraf_docs + '(' + doc.coverage + ')';
          }
        }
      });

    return (
      <div
        className={
          fdata.ehraf ||
          fdata.sccs ||
          fdata.ea ||
          fdata.ea_sum ||
          fdata.awc ||
          fdata.srs ||
          fdata.psf ||
          fdata.ses ||
          fdata.wes ||
          fdata.fiche
            ? 'ui raised segments'
            : 'hide-element'
        }
      >
        {fdata.ehraf && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-ehraf`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-ehraf`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              eHRAF World Cultures
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-ehraf`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.ehraf.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.ehraf.id}</div>
                    </div>
                  </div>
                )}
                {fdata.ehraf.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.ehraf.name}</div>
                    </div>
                  </div>
                )}
              </div>

              {fdata.ehraf_docs.length !== 0 && (
                <table className='ui celled table'>
                  <thead>
                    <tr>
                      <th>OWC</th>
                      <th>Document No</th>
                      <th>Coverage</th>
                      <th>Author</th>
                      <th>Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fdata.ehraf_docs.map((doc, docindex) => (
                      <tr key={docindex}>
                        <td><a href={`https://ehrafworldcultures.yale.edu/cultures/${doc.owc.toLowerCase()}`}>{doc.owc}</a></td>
                        <td>{doc.document_no}</td>
                        <td>{doc.coverage}</td>
                        <td>{doc.author}</td>
                        <td>
                          <a
                            href={`http://ehrafworldcultures.yale.edu/document?id=${doc.owc.toLowerCase()}-${this.padZero(
                              doc.document_no,
                              3
                            )}`}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {doc.title} ({doc.date})
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {fdata.sccs && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-sccs`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-sccs`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Standard Cross-Cultural Sample
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-sccs`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.sccs.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.sccs.id}</div>
                    </div>
                  </div>
                )}
                {fdata.sccs.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.sccs.name}</div>
                    </div>
                  </div>
                )}
                {fdata.sccs.date !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Time
                      <div className='detail'>{fdata.sccs.date}</div>
                    </div>
                  </div>
                )}
                {fdata.sccs.note !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Note
                      <div className='detail'>{fdata.sccs.note}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.ea && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-ea`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-ea`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Ethnographic Atlas
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-ea`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.ea.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.ea.id}</div>
                    </div>
                  </div>
                )}
                {fdata.ea.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.ea.name}</div>
                    </div>
                  </div>
                )}
                {fdata.ea.date !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Time
                      <div className='detail'>{fdata.ea.date}</div>
                    </div>
                  </div>
                )}
                {fdata.ea.note !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Note
                      <div className='detail'>{fdata.ea.note}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.ea_sum && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-easum`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-easum`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Ethnographic Atlas Summary
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-easum`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.ea_sum.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.ea_sum.id}</div>
                    </div>
                  </div>
                )}
                {fdata.ea_sum.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.ea_sum.name}</div>
                    </div>
                  </div>
                )}
                {fdata.ea_sum.date !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Time
                      <div className='detail'>{fdata.ea_sum.date}</div>
                    </div>
                  </div>
                )}
                {fdata.ea_sum.note !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Note
                      <div className='detail'>{fdata.ea_sum.note}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.awc && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-awc`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-awc`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Atlas of World Cultures
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-awc`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.awc.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.awc.id}</div>
                    </div>
                  </div>
                )}
                {fdata.awc.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.awc.name}</div>
                    </div>
                  </div>
                )}
                {fdata.awc.date !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Time
                      <div className='detail'>{fdata.awc.date}</div>
                    </div>
                  </div>
                )}
                {fdata.awc.note !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Note
                      <div className='detail'>{fdata.awc.note}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.srs && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-srs`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-srs`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Simple Random Sample (HRAF)
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-srs`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.ehraf && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      eHRAF Source
                      <div className='detail'>{ehraf_docs}</div>
                    </div>
                  </div>
                )}
                {fdata.fiche && fdata.fiche.source !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Fiche Source
                      <div className='detail'>{fdata.fiche.source}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.psf && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-psf`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-psf`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Probability Sample Files (HRAF)
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-psf`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.psf.cluster_no !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Cluster No
                      <div className='detail'>{fdata.psf.cluster_no}</div>
                    </div>
                  </div>
                )}
                {fdata.psf.cluster_name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Cluster Name
                      <div className='detail'>{fdata.psf.cluster_name}</div>
                    </div>
                  </div>
                )}
                {fdata.ehraf && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      eHRAF Source
                      <div className='detail'>{ehraf_docs}</div>
                    </div>
                  </div>
                )}
                {fdata.fiche && fdata.fiche.source !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Fiche Source
                      <div className='detail'>{fdata.fiche.source}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.ses && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-ses`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-ses`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              Standard Ethnographic Sample
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-ses`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.ses.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.ses.name}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.wes && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-wes`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-wes`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              World Ethnographic Sample
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-wes`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.wes.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.wes.name}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {fdata.fiche && (
          <div className='sample-div'>
            <h5
              className='ui top attached header sample-header'
              onClick={() => this.onClickSample(`${fdata.focusID}-fiche`)}
            >
              {this.state.openSamples.includes(`${fdata.focusID}-fiche`) ? (
                <i className='caret down icon'></i>
              ) : (
                <i className='caret right icon'></i>
              )}{' '}
              HRAF Fiche
            </h5>
            <div
              className={
                this.state.openSamples.includes(`${fdata.focusID}-fiche`)
                  ? 'ui attached segment'
                  : 'hide-element'
              }
            >
              <div className='ui large horizontal list'>
                {fdata.fiche.id !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      ID
                      <div className='detail'>{fdata.fiche.id}</div>
                    </div>
                  </div>
                )}
                {fdata.fiche.name !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Name
                      <div className='detail'>{fdata.fiche.name}</div>
                    </div>
                  </div>
                )}
                {fdata.fiche.source !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Source
                      <div className='detail'>{fdata.fiche.source}</div>
                    </div>
                  </div>
                )}
                {fdata.fiche.note !== 'None' && (
                  <div className='item'>
                    <div className='ui large teal label'>
                      Note
                      <div className='detail'>{fdata.fiche.note}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
